export var Size;
(function (Size) {
    Size[Size["XSmall"] = 480] = "XSmall";
    Size[Size["Small"] = 576] = "Small";
    Size[Size["Medium"] = 768] = "Medium";
    Size[Size["Large"] = 992] = "Large";
    Size[Size["XLarge"] = 1200] = "XLarge";
    Size[Size["XXLarge"] = 1600] = "XXLarge";
})(Size || (Size = {}));
//# sourceMappingURL=Screen.js.map